const internshipCourseSeoDetails = {
  "android-app-development-using-java": {
    metaTags: {
      titleMetaTagContent:
        "Android App Development- Online course with Internship - Unschool",
      descriptionMetaTagContent:
        "Unschool is here with an App Development course with guaranteed Internship program for entry-level and expert developers.",
      keywordsMetaTagContent:
        "app development course,mobile app development course,mobile application development course,app development course for beginners,mobile app development course for beginners,app development course online,best app development course,application developer course,mobile app developer course,mobile app development training,app programming course,app development training,online internship in app development,internship in app development,app development online internship",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Android App Development",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool is here with an App Development course with guaranteed Internship program for entry-level and expert developers.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3.5",
          ratingCount: "25967",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "app development course",
      "mobile app development course",
      "mobile application development course",
      "app development course for beginners",
      "mobile app development course for beginners",
      "app development course online",
      "best app development course",
      "application developer course",
      "mobile app developer course",
      "mobile app development training",
      "app programming course",
      "app development training",
      "online internship in app development",
      "internship in app development",
      "app development online internship",
    ],
  },

  "stock-market-personal-finance": {
    metaTags: {
      titleMetaTagContent:
        "Online Stock Market & Personal Finance course 2022-Unschool",
      descriptionMetaTagContent:
        "Unschool is offering Online Stock Market & Personal Finance course for you with 100% Internship program.",
      keywordsMetaTagContent:
        "Online personal finance course,Personal finance course,Best personal finance course in India,stock market online course, stock market online course with certificate,best stock market courses online,Stock Market & Personal Finance course.",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Online Stock Market & Personal Finance course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool is offering Online Stock Market & Personal Finance course for you with 100% Internship program.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "28763",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "Online personal finance course",
      "Personal finance course",
      "Best personal finance course in India",
      "stock market online course",
      "stock market online course with certificate",
      "best stock market courses online",
      "Stock Market & Personal Finance course",
    ],
  },

  "advanced-microsoft-excel-certification": {
    metaTags: {
      titleMetaTagContent:
        "Advanced Microsoft Excel Course with certification-Unschool",
      descriptionMetaTagContent:
        "Unschool offers The Advanced Microsoft Excel Course certification with guaranteed internship program.",
      keywordsMetaTagContent:
        "advanced excel course,advanced excel course online,advanced excel course online with certificate,advanced excel certification,ms excel advanced course,advanced excel course with certification,microsoft excel advanced course,advance excel learning course,advanced excel course with internship,advanced excel certification with internship program,ms excel advanced internship program",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",

        name: "Advanced Microsoft Excel Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool offers The Advanced Microsoft Excel Course certification with guaranteed internship program.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3.5",
          ratingCount: "25467",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "advanced excel course",
      "advanced excel course online",
      "advanced excel course online with certificate",
      "advanced excel certification",
      "ms excel advanced course",
      "advanced excel course with certification",
      "microsoft excel advanced course",
      "advance excel learning course",
      "advanced excel course with internship",
      "advanced excel certification with internship program",
      "ms excel advanced internship program",
    ],
  },

  "product-management": {
    metaTags: {
      titleMetaTagContent:
        "Product management course certification 2022- Unschool",
      descriptionMetaTagContent:
        "Unschool offers product management course certification for you with 100% guaranteed Internship program.",
      keywordsMetaTagContent:
        "Product management course,product management internship,product management certification,product management training,best product management certification,digital product management certification,brand management certification,product management internship program,product management internship work from home,online product management course,online internship in product management,product management internship certificate",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Product Management",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool offers product management course certification for you with 100% online internship program guaranteed.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",

          worstRating: "3",
          ratingCount: "24390",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "product management course",
      "product management internship",
      "product management certification",
      "product management training",
      "best product management certification",
      "digital product management certification",
      "brand management certification",
      "product management internship program",
      "product management internship work from home",
      "online product management course",
      "online internship in product management",
      "product management internship certificate",
    ],
  },

  "public-relations": {
    metaTags: {
      titleMetaTagContent:
        "Public relation online course with Internship - Unschool",
      descriptionMetaTagContent:
        "Unschool offers Public Relation course certification for you. Take a Public Relations course with an internship to explore more about it.",
      keywordsMetaTagContent:
        "Public relations online course,public relations training online,public relations online internship,public relations course with internship,public relations online course in India,public relations online course in hyderabad,diploma in public relations,internship in public relation,online internship in Public relation",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Public Relation Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool offers Public Relation course certification for you. Take a Public Relations course with an internship to explore more about it.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",

          worstRating: "3",
          ratingCount: "34723",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "public relations online course",
      "public relations training online",
      "public relations online internship",
      "public relations course with internship",
      "public relations online course in India",
      "public relations online course in hyderabad",
      "diploma in public relations",
      "internship in public relation",
      "online internship in Public relation",
    ],
  },

  "advanced-artificial-intelligence-certification": {
    metaTags: {
      titleMetaTagContent:
        "Artificial Intelligence Course with 100% Internship-Unschool",
      descriptionMetaTagContent:
        "The Advanced Artificial Intelligence course is counted as one of the most in-demand courses today. Start with Unschool's Advanced AI course now.",
      keywordsMetaTagContent:
        "advanced artificial intelligence course,advanced artificial intelligence,advanced ai course,advanced topics in artificial intelligence,advanced diploma in artificial intelligence,artificial intelligence advanced ai,artificial intelligence course,best artificial intelligence course,artificial intelligence training,artificial intelligence course with internship,AI online internship with certificate,advanced ai certification,online internship in Artificial intelligence,internship in AI with certificate",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Advanced Artificial Intelligence",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "The Advanced Artificial Intelligence course is counted as one of the most in-demand courses today. Start with Unschool's Advanced AI course now.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3.5",
          ratingCount: "25467",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "advanced artificial intelligence course",
      "advanced artificial intelligence",
      "advanced ai course",
      "advanced topics in artificial intelligence",
      "advanced diploma in artificial intelligence",
      "artificial intelligence advanced ai",
      "artificial intelligence course",
      "best artificial intelligence course",
      "artificial intelligence training",
      "artificial intelligence course with internship",
      "AI online internship with certificate",
      "advanced ai certification",
      "online internship in Artificial intelligence",
      "internship in AI with certificate",
    ],
  },

  "full-stack-development": {
    metaTags: {
      titleMetaTagContent:
        "Internship based Full Stack Development Course-Unschool",
      descriptionMetaTagContent:
        "The Full Stack Dvelopment Course is counted as one of the most in-demand courses today. Start with Unschool's Full Stack Development Course now.",
      keywordsMetaTagContent:
        "full stack development course,full stack web development course,full stack developer course with internship,full stack course,full stack developer certification,best full stack developer course,full stack web developer course,full stack developer training,full stack certification,full stack internship,full stack developer online internship,online internship in full stack developer,internship in full stack development ,full stack development with certificate",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Full Stack Development Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "The Full Stack Development Course is counted as one of the most in-demand courses today. Start with Unschool's Full Stack Development Course now.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3.5",
          ratingCount: "25467",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "full stack development course",
      "full stack web development course",
      "full stack developer course with internship",
      "full stack course",
      "full stack developer certification",
      "best full stack developer course",
      "full stack web developer course",
      "full stack developer training",
      "full stack certification",
      "full stack internship",
      "full stack developer online internship",
      "online internship in full stack developer",
      "internship in full stack development",
      "full stack development with certificate",
    ],
  },

  "public-speaking-training": {
    metaTags: {
      titleMetaTagContent:
        "Public Speaking Course with Internship program 2022- Unschool",
      descriptionMetaTagContent:
        "Unschool offers Public Speaking course certification for you with 100% guaranteed Internship program.",
      keywordsMetaTagContent:
        "public speaking course,public speaking training,public speaking course online,public speaking skills training,best public speaking courses,public speaking classes online,public speaking courses for students,public speaking training online,public speaking online internship,public speaking internship,internship in public speaking,online internship in public speaking,public speaking internship with certificate",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Public Speaking Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool offers Public Speaking course certification for you with 100% guaranteed Internship program.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "34723",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "public speaking course",
      "public speaking training",
      "public speaking course online",
      "public speaking skills training",
      "best public speaking courses",
      "public speaking classes online",
      "public speaking courses for students",
      "public speaking training online",
      "public speaking  online internship",
      "public speaking  internship",
      "internship in public speaking",
      "online internship in public speaking",
      "public speaking internship with certificate",
    ],
  },

  "advanced-marketing-management-certification": {
    metaTags: {
      titleMetaTagContent:
        "Learn Marketing Management with Online Internship- Unschool",
      descriptionMetaTagContent:
        "If you're into business, entrepreneurship, management, marketing or brand, Marketing Management online course is a must-have !",
      keywordsMetaTagContent:
        "marketing management online course,brand management internship,online marketing management,marketing management internship,digital marketing project management course,social media marketing manager course,marketing management online,digital marketing manager certification,marketing management course free,marketing management certificate courses online,certificate course in marketing management,certificate for marketing management project,digital marketing manager training,digital marketing management certificate,marketing management distance learning,marketing management short courses,marketing management online courses free",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Marketing Management online course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "If you're into business, entrepreneurship, management, marketing or brand, Marketing Management online course is a must-have .",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "24390",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "marketing management online course",
      "brand management internship",
      "online marketing management",
      "marketing management internship",
      "digital marketing project management course",
      "social media marketing manager course",
      "marketing management online",
      "digital marketing manager certification",
      "marketing management course free",
      "marketing management certificate courses online",
      "certificate course in marketing management",
      "certificate for marketing management project",
      "digital marketing manager training",
      "digital marketing management certificate",
      "marketing management distance learning",
      "marketing management short courses",
      "marketing management online courses free",
    ],
  },

  "advanced-data-science-certification": {
    metaTags: {
      titleMetaTagContent:
        "Best Data Science Online Course with Training Program- Unschool",
      descriptionMetaTagContent:
        "Put on your learning caps with the top-rated Data Science online course on Unschool. The demand for data scientists who can analyze data and communicate results to inform data-driven decisions has never been out of date.",
      keywordsMetaTagContent:
        "data science course, data science online course, best data science courses, data analysis courses for beginners, data science certification course, data science online training, best data science courses online, best data science certification online, certificate in data science, data science and machine learning course, data science course near me, learn data science online, professional certificate in data science, data science full course, data science course for beginners, best online data science programs, best online data science internship programs, online data science internship programs, data science internship programs",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Data Science Online Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Put on your learning caps with the top-rated Data Science online course on Unschool. The demand for data scientists who can analyse data and communicate results to inform data-driven decisions has never been out of date.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "24390",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "data science course ",
      "data science online course ",
      "best data science courses ",
      "data analysis courses for beginners ",
      "data science certification course ",
      "data science online training ",
      "best data science courses online",
      "best data science certification online",
      "certificate in data science ",
      "data science and machine learning course ",
      "data science course near me",
      "learn data science online",
      "professional certificate in data science",
      "data science full course",
      "data science course for beginners ",
      "best online data science programs ",
      "best online data science internship programs",
      "online data science internship programs",
      "data science internship programs",
    ],
  },

  "advanced-copywriting": {
    metaTags: {
      titleMetaTagContent:
        "Copywriting course certification with Online Internship- Unschool",
      descriptionMetaTagContent:
        "Copywriting online course certification with internship program is a whole new ball game that can be mastered with the right skills and real industry insight.",
      keywordsMetaTagContent:
        "Copywriting course, Free copywriting courses with certificate,  Copywriting courses online, Best free copywriting courses, Professional copywriting courses, Copywriting courses in India, Copywriting courses for beginners, online copywriting course with certification, copywriting courses with certificate, copywriting online course with internship, copywriting internship program",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Copywriting online course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Copywriting online course certification with internship program is a whole new ball game that can be mastered with the right skills and real industry insight.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "24390",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "Copywriting course",
      "Free copywriting courses with certificate",
      "Copywriting courses online",
      "Best free copywriting courses",
      "Professional copywriting courses",
      "Copywriting courses in India",
      "Copywriting courses for beginners",
      "online copywriting course with certification",
      "copywriting courses with certificate",
      "copywriting online course with internship",
      "copywriting internship program",
    ],
  },

  "google-ads": {
    metaTags: {
      titleMetaTagContent: "Google ads Online Course & Training - Unschool",
      descriptionMetaTagContent:
        "This Google Ads online course will enable you to set up your Ads account, select the best keywords, write effective ad copy, and follow and optimize the execution of your ads. ",
      keywordsMetaTagContent:
        "google ads online course, ppc course, google ad certification, google adwords certification, google ads training, google ads specialist certification, google ad certification course, google advertising certification, best google ads course, certification for google ads, ppc training courses, google ads training course",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Google ads Online Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "This Google Ads online course will enable you to set up your Ads account, select the best keywords, write effective ad copy, and follow and optimize the execution of your ads.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "20320",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "google ads online course",
      "ppc course",
      "google ad certification",
      "google adwords certification",
      "google ads training",
      "google ads specialist certification",
      "google ad certification course",
      "google advertising certification",
      "best google ads course",
      "certification for google ads",
      "ppc training courses",
      "google ads training course",
    ],
  },

  "autodesk-revit-architecture-structure": {
    metaTags: {
      titleMetaTagContent:
        "Best Revit architecture online course with Internship- Unschool",
      descriptionMetaTagContent:
        "Unschool is the best online learning platform that offers a Revit structure online course to upskill you.",
      keywordsMetaTagContent:
        "Autodesk Revit architecture & structure, autodesk revit structure, autodesk revit structure 2023, revit structure advanced course, revit structure advanced course, advanced revit course, revit software course near me, revit software online course, revit structure online course, online revit courses for beginners, learn revit architecture from basic to advanced level",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Revit architecture online course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Unschool is the best online learning platform that offers a Revit structure online course to upskill you.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "24390",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "Autodesk Revit architecture & structure",
      "autodesk revit structure",
      "autodesk revit structure 2023",
      "revit structure advanced course",
      "advanced revit course",
      "revit software course near me",
      "revit software online course",
      "revit structure online course",
      "online revit courses for beginners",
      "learn revit architecture from basic to advanced level",
    ],
  },

  "advanced-python": {
    metaTags: {
      titleMetaTagContent:
        "Advanced Python Online Course with Internship - Unschool",
      descriptionMetaTagContent:
        "The Advanced Python course gives you a walk-through of all the basic concepts in python. Also, the core concepts are explained along with advanced concepts of python to help you to get an array of knowledge in python that can be implemented in your real-time projects.",
      keywordsMetaTagContent:
        "advanced python online course,advanced python course,best advanced python course,best python advanced course,python advanced certification,best course for advanced python,advanced python course online,advanced python developer course,advanced python training onlinebest advanced python course online,advanced python internship program.",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Advanced Python Online Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "The Advanced Python course gives you a walk-through of all the basic concepts in python. Also, the core concepts are explained along with advanced concepts of python to help you to get an array of knowledge in python that can be implemented in your real-time projects.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "20320",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "advanced python online course",
      "advanced python course",
      "best advanced python course",
      "best python advanced course",
      "python advanced certification",
      "best course for advanced python",
      "advanced python course online",
      "advanced python developer course",
      "advanced python training online",
      "best advanced python course online",
    ],
  },

  "design-thinking-professional-course": {
    metaTags: {
      titleMetaTagContent:
        "Unschool's Design thinking Online Course & Certification",
      descriptionMetaTagContent:
        "Design Thinking online course helps you leverage principles and innovative problem-solving tools to address business challenges and design products, strategies, teams, and environments for optimal use and performance.",
      keywordsMetaTagContent:
        "design thinking online course, design thinking course, design thinking certification, design thinking training, design thinking course free,best design thinking courses, design thinking online, Design thinking internship program, online design thinking course, design thinking course with internship",
      robotsMetaTagContent: "index, follow",
      httpEquivMetaTagContent: "text/html; charset=utf-8",
      languageMetaTagContent: "English",
      revisitAfterMetaTagContent: "1 days",
      authorMetaTagContent: "Unschool",
    },
    scriptTags: [
      {
        "@context": "https://schema.org/",
        "@type": "Product",
        name: "Design Thinking Online Course",
        image:
          "https://www.unschool.in/static/Unschool%20Logo%20Horizontal%20White%20(1)-a4913f0c391a347aa53acfa994243cb4.png",
        description:
          "Design Thinking online course helps you leverage principles and innovative problem-solving tools to address business challenges and design products, strategies, teams, and environments for optimal use and performance.",
        brand: "Unschool",
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: "5",
          bestRating: "5",
          worstRating: "3",
          ratingCount: "18320",
        },
        sku: "Internship Program",
        mpn: "UA-134257618-1",
      },
    ],
    imageAltAttributes: [
      "design thinking online course",
      "design thinking course",
      "design thinking certification",
      "design thinking training",
      "design thinking course free",
      "best design thinking courses",
      "design thinking online",
      "Design thinking internship program",
      "online design thinking course",
      "design thinking course with internship",
    ],
  },
};

export default internshipCourseSeoDetails;
